<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- 戻る -->
    <div class="return">
      <button
        pButton
        type="button"
        label="会員検索へ戻る"
        icon="pi pi-angle-left"
        class="p-button-text"
        (click)="moveA110()"
      ></button>
    </div>

    <!-- タイトル -->
    <div class="p-d-flex title p-ai-center">
      <!-- 会員名 -->
      <label class="member-name">
        {{ memberInformation?.organization_name }}
      </label>
      <div
        class="future-city-badge p-d-flex p-ml-3"
        *ngIf="memberInformation?.flag_future_city == '1'"
      >
        <div class="icon">
          <img
            src="../../../../assets/images/logo2.png"
            alt="future-city-badge-icon"
          />
        </div>
        <div class="text">未来都市</div>
      </div>
      <!-- ホームページ -->
      <button
        pButton
        type="button"
        label="ホームページ"
        icon="pi pi-clone"
        iconPos="right"
        [value]="memberInformation?.url"
        onClick="window.open(this.value)"
        class="p-as-center button2 home"
        *ngIf="memberInformation?.url"
      ></button>

      <!-- 編集 -->
      <button
        pButton
        type="button"
        label="編集する"
        icon="pi pi-pencil"
        class="p-as-center button1 edit"
        (click)="moveB101(memberInformation?.class_id.id)"
        *ngIf="
          decisionPerspective(memberInformation?.member_id) ||
          decisionSecretariat()
        "
      ></button>
    </div>

    <!-- 課題・ソリューション・連携事例 -->
    <div class="task-information" *ngIf="taskDisplayJudgment()">
      <!-- 課題・ソリューション・連携事例タイトル -->
      <div class="task-title">
        <h1>課題・ソリューション・連携事例</h1>
      </div>

      <!-- 課題・ソリューション・連携事例エリア -->
      <div class="task-area">
        <ng-container *ngFor="let task of taskList">
          <!-- 課題・ソリューション・連携事例 -->
          <div
            pButton
            type="button"
            icon="pi pi-angle-right"
            iconPos="right"
            class="task-button"
            [class.task-past]="
              task.past_issue == '1' && task.agenda_kbn.id == 1
            "
            (click)="moveC301orMoveH301(task.agenda_kbn.id, task.agenda_id)"
            *ngIf="0 != releaseFlag(
              task.status.id,
              task.end_date,
              task.agenda_kbn.id,
              task.past_issue
            )"
          >
            <div class="task-data">
              <!-- 課題タイトル -->
              <div class="task-data-title">
                {{ task.title }}
              </div>
              <div class="p-d-flex task-data-end  p-jc-between">
                <div class="p-d-flex">
                  <!-- 課題区分 -->
                  <div class="p-as-center">
                    <!-- 区分が1の場合 -->
                    <p-tag
                      value="課題"
                      styleClass="task-tag"
                      *ngIf="1 == task.agenda_kbn.id"
                    ></p-tag>
                    <!-- 区分が2の場合 -->
                    <p-tag
                      value="ソリューション"
                      styleClass="solution-tag"
                      *ngIf="2 == task.agenda_kbn.id"
                    ></p-tag>
                    <!-- 区分が9の場合 -->
                    <p-tag
                      value="連携事例"
                      styleClass="jirei-tag"
                      *ngIf="9 == task.agenda_kbn.id"
                    ></p-tag>
                  </div>
                  <!-- 公開タグ-->
                  <div class="p-as-center task-data-release-kbn task-data-tag">
                    <!-- 区分が1の場合 -->
                    <p-tag
                      value="公開"
                      [rounded]="true"
                      styleClass="release-public-tag"
                      *ngIf="1 ==
                        releaseFlag(
                          task.status.id,
                          task.end_date,
                          task.agenda_kbn.id,
                          task.past_issue
                        )
                      "
                    ></p-tag>
                    <!-- 区分が2の場合 -->
                    <p-tag
                      value="非公開"
                      [rounded]="true"
                      styleClass="release-private-tag"
                      *ngIf="2 ==
                        releaseFlag(
                          task.status.id,
                          task.end_date,
                          task.agenda_kbn.id,
                          task.past_issue
                        )
                      "
                    ></p-tag>
                  </div>
                  <div class="p-as-center task-data-tag">
                    No.{{ task.agenda_id }}
                  </div>
                  <div class="p-as-center task-data-tag">
                    登録日時：{{ task.create_datetime }}
                  </div>
                </div>
                <!-- fpt's part start: add follow button -->
                <div
                  *ngIf="task?.agenda_kbn.id == '1' && task?.past_issue == '0' && task.created_by_follow !='1'"
                  class="ml-1 p-d-flex p-jc-end"
                >
                  <ng-container *ngIf="task.is_followed == 0; else followed">
                    <button
                      type="button"
                      class="follow-button"
                      (click)="
                        $event.stopPropagation();
                        openConfirmFollowdialog(
                          task.agenda_id,
                          task.member_id,
                          task.title
                        )
                      "
                    >課題をフォロー
                    {{
                      task.follower_count >= 9999
                        ? '(9999)'
                        : task.follower_count <= 0
                        ? ''
                        : '(' + task.follower_count + ')'
                    }}</button>
                  </ng-container>

                  <ng-template #followed>
                    <button
                      type="button"
                      [disabled]="!loginUser"
                      class="unFollow-button"
                      (click)="
                        $event.stopPropagation();
                        openConfirmUnFollowdialog(task.agenda_id, task.title)
                      "
                    >
                      フォロー済
                      {{
                        task.follower_count >= 9999
                          ? '(9999)'
                          : task.follower_count <= 0
                          ? ''
                          : '(' + task.follower_count + ')'
                      }}
                    </button>
                  </ng-template>
                </div>
                <!-- fpt's part end -->
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- 内閣府承認情報 -->
    <div
      class="approval-information"
      *ngIf="
        decisionPerspective(this.memberInformation?.member_id) ||
        decisionSecretariat()
      "
    >
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == memberInformation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ memberInformation?.status.name }}
                    </label>
                    <!-- 承認日付 -->
                    <label>
                      {{ memberInformation?.status_datetime }}
                    </label>
                  </label>

                  <div>
                    <!-- 前後確認 -->
                    <button
                      pButton
                      type="button"
                      label="前後確認"
                      class="button3 approval-button"
                      (click)="openDiffDialog('b212')"
                      *ngIf="decisionSecretariat()"
                    ></button>
                    <!-- 承認可否 -->
                    <button
                      pButton
                      type="button"
                      label="承認可否を登録する"
                      class="button3 approval-button"
                      (click)="openSmallApprovalDialog()"
                      *ngIf="decisionSecretariat()"
                    ></button>
                  </div>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ memberInformation?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 会員情報 -->
    <div class="member-information">
      <div class="task-title">
        <h1>会員プロフィール</h1>
      </div>

      <!-- 会員情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 会員種別 -->
          <tr>
            <td class="item-name">会員種別</td>
            <td class="item-information">
              <label *ngIf="9 != memberInformation?.class_id.id">
                {{ memberInformation?.class_id.name }}
              </label>
              <label *ngIf="9 == memberInformation?.class_id.id">
                事務局
              </label>
            </td>
          </tr>
          <!--団体名称(フリガナ） -->
          <tr>
            <td class="item-name">団体名称(フリガナ）</td>
            <td class="item-information">
              {{ memberInformation?.organization_kana }}
            </td>
          </tr>
          <!-- 法人番号 -->
          <tr>
            <td class="item-name">法人番号</td>
            <td class="item-information">
              {{ memberInformation?.organization_no }}
            </td>
          </tr>
          <!-- 郵便番号 -->
          <tr>
            <td class="item-name">郵便番号</td>
            <td class="item-information">
              {{ memberInformation?.postal_no }}
            </td>
          </tr>
          <!-- 都道府県 -->
          <tr>
            <td class="item-name">都道府県</td>
            <td class="item-information">
              {{ memberInformation?.prefectures }}
            </td>
          </tr>
          <!-- 所在地 -->
          <tr>
            <td class="item-name">所在地</td>
            <td class="item-information">
              {{ memberInformation?.city }}
              {{ memberInformation?.town_area }}
              {{ memberInformation?.address_building }}
            </td>
          </tr>
          <!-- 業種 -->
          <tr>
            <td class="item-name">業種</td>
            <td class="item-information">
              {{ memberInformation?.industry_id.name }}
            </td>
          </tr>
          <!-- 従業員数 -->
          <tr *ngIf="3 == memberInformation?.class_id.id">
            <td class="item-name">従業員数</td>
            <td class="item-information">
              {{ memberInformation?.employees_count.name }}
            </td>
          </tr>
          <!-- 売上高 -->
          <tr *ngIf="3 == memberInformation?.class_id.id">
            <td class="item-name">売上高</td>
            <td class="item-information">
              {{ memberInformation?.sales_amount.name }}
            </td>
          </tr>
          <!-- 活動で貴団体が実現したいこと -->
          <tr>
            <td class="item-name">
              本プラットフォームにおける<br />
              活動で実現したいこと
            </td>
            <td class="item-information">
              {{ memberInformation?.want }}
            </td>
          </tr>
          <!-- 主要事業 -->
          <tr>
            <td class="item-name">主要事業</td>
            <td class="item-information">
              {{ memberInformation?.primary_business }}
            </td>
          </tr>
          <!-- 重点的に取り組みたいテーマ -->
          <tr>
            <td class="item-name">重点的に取り組みたいテーマ</td>
            <td class="item-information">
              <div
                *ngFor="
                  let category_activities_forcus of memberInformation?.category_activities_forcus
                "
              >
                {{ category_activities_forcus.name }}
              </div>
            </td>
          </tr>
          <!-- 目指すSDGsゴール -->
          <tr>
            <td class="item-name">目指すSDGsゴール</td>
            <td class="item-information target">
              <div
                class="image"
                *ngFor="
                  let category_activities of memberInformation?.category_activities
                "
              >
                <img [src]="category_activities.sp_ext" alt="image" />
              </div>
            </td>
          </tr>
          <!-- 現在のSDGsに関する取組 -->
          <tr>
            <td class="item-name">現在のSDGsに関する取組</td>
            <td class="item-information">
              {{ memberInformation?.activities_now }}
            </td>
          </tr>
          <!-- 今後取り組みたい内容 -->
          <tr>
            <td class="item-name">今後取り組みたい内容</td>
            <td class="item-information">
              {{ memberInformation?.activities_future }}
            </td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="memberInformation?.pap_ally1_title">
            <td class="item-name">官民連携事例1</td>
            <td class="item-information">
              【案件名】<br />
              {{ memberInformation?.pap_ally1_title }}<br />
              【連携団体名】<br />
              {{ memberInformation?.pap_ally1_member_name }}<br />
              【詳細】<br />
              {{ memberInformation?.pap_ally1_note }}
            </td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="memberInformation?.pap_ally2_title">
            <td class="item-name">官民連携事例2</td>
            <td class="item-information">
              【案件名】<br />
              {{ memberInformation?.pap_ally2_title }}<br />
              【連携団体名】<br />
              {{ memberInformation?.pap_ally2_member_name }}<br />
              【詳細】<br />
              {{ memberInformation?.pap_ally2_note }}
            </td>
          </tr>
          <!-- 官民連携事例 -->
          <tr *ngIf="memberInformation?.pap_ally3_title">
            <td class="item-name">官民連携事例3</td>
            <td class="item-information">
              【案件名】<br />
              {{ memberInformation?.pap_ally3_title }}<br />
              【連携団体名】<br />
              {{ memberInformation?.pap_ally3_member_name }}<br />
              【詳細】<br />
              {{ memberInformation?.pap_ally3_note }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 官民連携事例 -->
    <!-- <div
      class="case-information"
      *ngIf="
        memberInformation?.pap_ally1_title ||
        memberInformation?.pap_ally2_title ||
        memberInformation?.pap_ally3_title
      "
    > -->
    <!-- 官民連携事例タイトル -->
    <!-- <div class="case-information-title">
        <h1>官民連携事例</h1>
      </div> -->

    <!-- 官民連携事例エリア -->
    <!-- <div class="case-area"> -->
    <!-- 官民連携事例1 -->
    <!-- <div class="case" *ngIf="memberInformation?.pap_ally1_title">
          <div class="case-title">
            案件名：{{ memberInformation?.pap_ally1_title }}
          </div>
          <div class="case-member-name">
            連携団体名：{{ memberInformation?.pap_ally1_member_name }}
          </div>
          <div class="case-note">
            詳細：{{ memberInformation?.pap_ally1_note }}
          </div>
        </div> -->

    <!-- 官民連携事例2 -->
    <!-- <div class="case" *ngIf="memberInformation?.pap_ally2_title">
          <div class="case-title">
            案件名：{{ memberInformation?.pap_ally2_title }}
          </div>
          <div class="case-member-name">
            連携団体名：{{ memberInformation?.pap_ally2_member_name }}
          </div>
          <div class="case-note">
            詳細：{{ memberInformation?.pap_ally2_note }}
          </div>
        </div> -->

    <!-- 官民連携事例3 -->
    <!-- <div class="case" *ngIf="memberInformation?.pap_ally3_title">
          <div class="case-title">
            案件名：{{ memberInformation?.pap_ally3_title }}
          </div>
          <div class="case-member-name">
            連携団体名：{{ memberInformation?.pap_ally3_member_name }}
          </div>
          <div class="case-note">
            詳細：{{ memberInformation?.pap_ally3_note }}
          </div>
        </div>
      </div>
    </div> -->

    <div
      class="task-request"
      *ngIf="decisionPerspective(this.memberInformation?.member_id)"
    >
      <!-- 課題依頼タイトル -->
      <div class="p-d-flex p-jc-center task-request-title">
        <h1>課題やソリューションを登録して提案を募集しましょう</h1>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center">
        <button
          pButton
          type="button"
          label="課題を登録する"
          class="button-default-size button1"
          (click)="moveC101(1)"
        ></button>
        <button
          pButton
          type="button"
          label="ソリューションを登録する"
          class="button-default-size button3"
          (click)="moveC101(2)"
        ></button>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getMemberInformation()"
></app-approval-dialog>

<!-- 共通部品_差分比較ダイアログ -->
<app-diff-table></app-diff-table>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
<app-follow-dialog (returnValue)="(getTaskInformation())"></app-follow-dialog>
